import React, { useEffect, useState, useRef } from "react";
import ReactECharts from "echarts-for-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import axios from "axios";
import { BASE_URL } from "../../../commonConfig/ApiConfig";
import ColorPalette from './charts_color';
import { FaFilter, FaSlidersH, FaChevronUp, FaChevronDown } from "react-icons/fa";
import Piechart_FilterPopup from "./filtercomponents/Piechart_filter";
//import { overflow } from "html2canvas/dist/types/css/property-descriptors/overflow";
import WorkspaceSidePanel from "components/cmn_workspace/workspace_button";
import WorkspaceButton from "components/pages/workspacebtn/workspacebtn";
import { setWorkspaceLoaded } from 'store/workspaceSlice';
import { MdInfoOutline } from "react-icons/md";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useBreakpoints } from 'hooks/useBreakpoints';
import SaveCharts from 'components/pages/map/mapConfig/SaveChart';

const PieChart = ({ chart_location_payload }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { breakpoints } = useBreakpoints();
  //=========== Mobile View =============
  const isMobile = breakpoints.down('md');

  const { formattedPayload, payload, reduxPayload } = location.state || {};
  const [isChartOptionOpen, setChartOptionOpen] = useState(false);
  const [selectedPalette, setSelectedPalette] = useState(['#5470C6', '#91CC75', '#EE6666', '#f7be47', '#62b3d6', '#8c6d31', '#6e4a1f']);
  const mainpayload = chart_location_payload || payload;
  const mainformattedpayload = chart_location_payload || formattedPayload;
  const isLocationPage = location.pathname.includes("/location");
  const [currentPayload, setCurrentPayload] = useState(mainpayload);
  const [currentFormattedPayload, setCurrentFormattedPayload] = useState(mainformattedpayload);
  const [selectedItems, setSelectedItems] = useState([]);
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isDonut, setDonut] = useState(false)
  const chartRef = useRef(null);
  const [isExportDropdownOpen, setExportDropdownOpen] = useState(false);
  // Workspace toggle state
  const [showWorkspace, setShowWorkspace] = useState(true);
  const dispatch = useDispatch();
  const selectedMapFeatures = useSelector(state => state.workspace.selectedMapFeatures);
  const handleVisualize = (selectedIndicators) => {
    navigate('/mapconfig', { state: { selectedIndicators, selectedMapFeatures } });
  };
  const handleSaveSuccess = (workspaceData) => {
    alert(`Workspace "${workspaceData.name}" saved successfully!`);

    // Always load the saved workspace as current
    if (workspaceData.id && workspaceData.name) {
      setTimeout(() => {
        dispatch(setWorkspaceLoaded({
          id: workspaceData.id,
          name: workspaceData.name,
          workspace: workspaceData
        }));
      }, 100);
    }
  };

  const [showFilterPopup, setShowFilterPopup] = useState(false);
  useEffect(() => {
    // ✅ Always define handlers, but conditionally check inside
    const handleClickOutside = (event) => {
      // Only process if at least one dropdown is open
      if (!isExportDropdownOpen && !isChartOptionOpen) return;

      const exportButton = document.querySelector('.btn.btn-sm.btn-primary');
      const exportMenu = document.querySelector('.dropdown-menu.show');
      const chartButton = document.querySelector('.btn.btn-primary:not(.btn-sm)');
      const chartMenu = document.querySelector('.position-absolute.bg-white');

      // Close export dropdown if click outside
      if (
        isExportDropdownOpen &&
        exportMenu &&
        !exportMenu.contains(event.target) &&
        exportButton &&
        !exportButton.contains(event.target)
      ) {
        setExportDropdownOpen(false);
      }

      // Close chart options if click outside
      if (
        isChartOptionOpen &&
        chartMenu &&
        !chartMenu.contains(event.target) &&
        chartButton &&
        !chartButton.contains(event.target)
      ) {
        setChartOptionOpen(false);
      }
    };

    const handleEscKey = (event) => {
      // Only process if at least one dropdown is open
      if (!isExportDropdownOpen && !isChartOptionOpen) return;

      if (event.key === 'Escape') {
        setExportDropdownOpen(false);
        setChartOptionOpen(false);
      }
    };

    // ✅ Always attach listeners (lightweight operations)
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscKey);

    // ✅ Always cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isExportDropdownOpen, isChartOptionOpen]);

  const [selectedLocations, setSelectedLocations] = useState(
    (mainformattedpayload?.location_info || [])
      .filter((loc) => {
        const locCode = loc.code || loc.properties?.code || loc.lgd_code;
        const geoLevel = loc.geo_level || loc.geo_level_code;

        return (mainpayload?.lgd_codes || []).some(
          (lgd) => lgd.code === locCode && lgd.geo_level_code === geoLevel
        );
      })
      .map((loc) => ({
        label: loc.name || loc.label,
        value: loc.code || loc.properties?.code || loc.lgd_code,
        geo_level: loc.geo_level || loc.geo_level_code,
        id: `${loc.geo_level || loc.geo_level_code}-${loc.code || loc.properties?.code || loc.lgd_code}`,
      }))
  );


  useEffect(() => {
    if (mainformattedpayload.chartType === "pie") {
      setDonut(false)
    } else if (isLocationPage) {
      setDonut(false)
    }
    else {
      setDonut(true)
    }
  }, [mainformattedpayload])
  // Fetch Pie chart data from API
  useEffect(() => {
    const fetchData = async () => {
      if (!currentPayload) return;
      try {
        const res = await axios.post(
          `${BASE_URL}indicators/pie-chart`,
          currentPayload
        );
        setApiData(res.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to fetch chart data.");
        setLoading(false);
      }
    };
    fetchData();
  }, [currentPayload]);
  // A function to fetch child locations dynamically
  const fetchLocations = async (lgd_code, geo_level_code) => {
    try {
      const res = await axios.post(`${BASE_URL}locations/location-details`, {
        lgd_code,
        geo_level_code,
      });
      return res.data.locations || [];
    } catch (err) {
      console.error("Error fetching locations:", err);
      return [];
    }
  };

  // Handle apply from popup
  // const handleFilterApply = (newSelected) => {
  //   // newSelected: array of { label, value, geo_level, id }
  //   setSelectedLocations(newSelected);
  //   const fetchData = async (payload) => {
  //     try {
  //       const res = await axios.post(`${BASE_URL}indicators/pie-chart`, payload);
  //       setApiData(res.data);
  //       setLoading(false);
  //     } catch (err) {
  //       console.error("Error fetching data:", err);
  //       setError("Failed to fetch chart data.");
  //       setLoading(false);
  //     }
  //   };

  //   const updatedPayload = {
  //     ...mainpayload,
  //     lgd_codes: newSelected.map((loc) => ({
  //       code: loc.lgd_code,
  //       geo_level_code: loc.geo_level,
  //     })),
  //   };

  //   setApiData(null);
  //   setLoading(true);
  //   fetchData(updatedPayload);
  // };
  const handleFilterApply = (selectedItemsFromPopup, oldpayload) => {
    if (!selectedItemsFromPopup || selectedItemsFromPopup.length === 0) {
      alert("Please select at least one location");
      return;
    }

    // ✅ Step 1: Get existing items from old payload
    const existingCodes = (oldpayload?.lgd_codes || []).map(item => ({
      code: item.code,
      geo_level_code: item.geo_level_code
    }));

    const existingLocations = (oldpayload.selected_Location || []).map(item => ({
      value: item.value,
      label: item.label,
      geo_level: item.geo_level
    }));

    // ✅ Step 2: Create sets for comparison (using lgd_code as key)
    const existingCodesSet = new Set(
      existingCodes.map(item => `${item.code}-${item.geo_level_code}`)
    );

    const selectedCodesSet = new Set(
      selectedItemsFromPopup.map(item => `${item.lgd_code}-${item.geo_level}`)
    );

    // ✅ Step 3: Filter out items from old payload that are NOT in selected
    const filteredExistingCodes = existingCodes.filter(item =>
      selectedCodesSet.has(`${item.code}-${item.geo_level_code}`)
    );

    const filteredExistingLocations = existingLocations.filter(item =>
      selectedCodesSet.has(`${item.value}-${item.geo_level}`)
    );

    // ✅ Step 4: Add new items that are NOT in old payload
    const newItemsToAdd = selectedItemsFromPopup.filter(item =>
      !existingCodesSet.has(`${item.lgd_code}-${item.geo_level}`)
    );

    const newCodesToAdd = newItemsToAdd.map(item => ({
      code: item.lgd_code,
      geo_level_code: item.geo_level
    }));

    const newLocationsToAdd = newItemsToAdd.map(item => ({
      value: item.lgd_code,
      label: item.name,
      geo_level: item.geo_level
    }));

    // ✅ Step 5: Combine filtered existing + new items
    const finalCodes = [...filteredExistingCodes, ...newCodesToAdd];
    const finalLocations = [...filteredExistingLocations, ...newLocationsToAdd];

    // ✅ Step 6: Create updated payload
    const updatedPayload = {
      ...oldpayload,
      lgd_codes: finalCodes,
      selected_Location: finalLocations,
    };

    //to know wht is being add or deleted from the old payload
    // console.log("📌 Applying filters:", {
    //     existingCount: existingCodes.length,
    //     selectedCount: selectedItemsFromPopup.length,
    //     removedCount: existingCodes.length - filteredExistingCodes.length,
    //     addedCount: newItemsToAdd.length,
    //     finalCount: finalCodes.length
    // });

    setSelectedItems(selectedItemsFromPopup); // ✅ Update selected UI list
    setCurrentPayload(updatedPayload);        // ✅ This triggers bar chart API fetch
    //setCurrentFormattedPayload(updatedPayload); // For navigation or config
  };
  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!apiData?.indicator_values || apiData.indicator_values.length === 0)
    return (
      <>
        <div className="container-fluid mt-4">
          <div className="alert alert-info p-4">
            <h4 className="alert-heading">No data available</h4>
            <hr />
            <p className="mb-2"><strong>Possible Reasons:</strong></p>
            <ul className="mb-0">
              <li className="mb-2">Selected Locations do not match the Geo levels of the selected indicators</li>
              <li className="mb-2">
                Selected indicator values do not exist for the selected locations. Verify this by visiting the locations pages and click on Show Indicator button. The location pages list all indicators having data available for the selected location or its sub levels.
                <p className="mt-2 ms-3"><em>Ex: In Karnataka page, the show indicators will list the indicators having data for Karnataka, its districts and its ULBs.</em></p>
              </li>
            </ul>
            <div className="text-end">
              <button className="btn btn-primary" onClick={() => navigate('/mapconfig', { state: currentFormattedPayload })}>
                <FaSlidersH className="me-1" /> Go Back to Chart Configuration
              </button>
            </div>
          </div>
        </div>
      </>
    );
  const total = apiData.indicator_values.length;

  // Build a master option with multiple pies, each using its own dataset
  const buildMultiPieOption = () => {
    const indicators = apiData.indicator_values || [];

    // Flatten all (indicator, location) pairs into a list of pies
    const pies = [];
    const datasets = [];

    indicators.forEach((ind) => {
      ind.location_values?.forEach((loc) => {
        const source = [["name", "value"]];

        loc.values?.forEach((item) => {
          const [key, value] = Object.entries(item)[0];
          const numVal = parseFloat(value);
          //if (!isNaN(numVal)) {
          if (!isNaN(numVal) && numVal !== 0) {
            source.push([key, numVal]);
          }
        });

        // Push dataset and corresponding pie info
        datasets.push({ source });
        pies.push({
          indicatorName: ind.indicator_name,
          indicator_date: ind.indicator_date,
          locationName: loc.location_name,
          geolevel: loc.geo_level,
          unit: ind.unit,
        });
      });
    });

    const total = pies.length;

    const getTitleTop = (centerY, total) => {
      const y = parseFloat(centerY);
      if (!isMobile) {
        switch (total) {
          case 1: return `${y - 40}%`;
          case 2: return `${y - 40}%`;
          case 3: return `${y - 27}%`;
          case 4: return `${y - 25}%`;
          default: return `${y - 20}%`;
        }
      } else {
        switch (total) {
          case 1: return `${y - 40}%`;
          case 2: return `${y - 23}%`;
          case 3: return `${y - 20}%`;
          case 4: return `${y - 15}%`;
          default: return `${y - 20}%`;
        }
      }
    };

    const formatTitle = (title) => {
      if (!title) return "";
      if (title.length <= 50) return title;

      const words = title.split(" ");
      let line = "";
      const lines = [];

      words.forEach((word) => {
        if ((line + word).length <= 70) {
          line += word + " ";
        } else {
          lines.push(line.trim());
          line = word + " ";
        }
      });

      if (line) lines.push(line.trim());
      return lines.join("\n");
    };

    const series = [];
    const titles = [];
    // PIE layout
    // const getPieCenterAndRadius = (idx, total) => {
    //   if (total === 1) return { center: ["50%", "45%"], radius: "40%" };
    //   if (total === 2) return [{ center: ["25%", "50%"], radius: "35%" }, { center: ["75%", "50%"], radius: "35%" }][idx];
    //   if (total === 3) return [{ center: ["30%", "30%"], radius: "25%" }, { center: ["70%", "30%"], radius: "25%" }, { center: ["50%", "80%"], radius: "25%" }][idx];
    //   if (total === 4) return [{ center: ["25%", "25%"], radius: "21%" }, { center: ["75%", "25%"], radius: "21%" }, { center: ["27%", "75%"], radius: "21%" }, { center: ["75%", "75%"], radius: "21%" }][idx];
    //   return { center: ["50%", "50%"], radius: "40%" };
    // };
    const getPieCenterAndRadius = (idx, total) => {
      if (!isMobile) {
        // Mobile version (same as your original grid layout)
        if (total === 1)
          return { center: ["50%", "45%"], radius: "40%" };

        if (total === 2)
          return [
            { center: ["25%", "50%"], radius: "35%" },
            { center: ["75%", "50%"], radius: "35%" }
          ][idx];

        if (total === 3)
          return [
            { center: ["30%", "30%"], radius: "25%" },
            { center: ["70%", "30%"], radius: "25%" },
            { center: ["50%", "80%"], radius: "25%" }
          ][idx];

        if (total === 4)
          return [
            { center: ["25%", "25%"], radius: "21%" },
            { center: ["75%", "25%"], radius: "21%" },
            { center: ["27%", "75%"], radius: "21%" },
            { center: ["75%", "75%"], radius: "21%" }
          ][idx];

        return { center: ["50%", "50%"], radius: "40%" };

      } else {
        // Desktop version (stacked vertically, one below the other)
        if (total === 1)
          return { center: ["50%", "40%"], radius: "25%" };

        if (total === 2)
          return [
            { center: ["50%", "30%"], radius: "25%" },
            { center: ["50%", "70%"], radius: "25%" }
          ][idx];

        if (total === 3)
          return [
            { center: ["50%", "25%"], radius: "20%" },
            { center: ["50%", "55%"], radius: "20%" },
            { center: ["50%", "85%"], radius: "20%" }
          ][idx];

        if (total === 4)
          return [
            { center: ["50%", "15%"], radius: "18%" },
            { center: ["50%", "40%"], radius: "18%" },
            { center: ["50%", "60%"], radius: "18%" },
            { center: ["50%", "85%"], radius: "18%" }
          ][idx];

        return { center: ["50%", "50%"], radius: "35%" };
      }
    };


    // DONUT layout
    const getDonutCenterAndRadius = (idx, total) => {
      if (total === 1) return { center: ["50%", "45%"], radius: ["25%", "40%"] };
      if (total === 2) return [{ center: ["25%", "50%"], radius: ["20%", "35%"] }, { center: ["75%", "50%"], radius: ["20%", "35%"] }][idx];
      if (total === 3) return [{ center: ["30%", "30%"], radius: ["15%", "25%"] }, { center: ["70%", "30%"], radius: ["15%", "25%"] }, { center: ["50%", "80%"], radius: ["15%", "25%"] }][idx];
      if (total === 4) return [{ center: ["25%", "25%"], radius: ["13%", "21%"] }, { center: ["75%", "25%"], radius: ["13%", "21%"] }, { center: ["27%", "75%"], radius: ["13%", "21%"] }, { center: ["75%", "75%"], radius: ["13%", "21%"] }][idx];
      return { center: ["50%", "50%"], radius: ["30%", "50%"] };
    };

    // Select correct layout based on isDonut
    const getCenterAndRadius = (idx, total) => {
      return isDonut ? getDonutCenterAndRadius(idx, total) : getPieCenterAndRadius(idx, total);
    };


    pies.forEach((pie, idx) => {
      const { center, radius } = getCenterAndRadius(idx, total);
      const { indicatorName, indicator_date, locationName, geolevel, unit, } = pie;

      series.push({
        type: "pie",
        datasetIndex: idx,
        name: `${indicatorName} ${indicator_date} (${locationName})${geolevel} `,
        radius,
        center,
        encode: { itemName: "name", value: "value" },
        label: {
          show: true,
          position: "outside",
          formatter: function (params) {
            const val = params.value[0] || "";
            let value = params.value[1];
            if (unit === "Percentage") {
              value = value + "%";
            } else {
              value = value + " (" + params.percent + "%)";
            }
            const truncated =
              val.length > 25 ? val.substring(0, 30).trim() + "..." : val;
            return `{bold|${value}},${truncated}`;
          },
          textStyle: {
            rich: {
              bold: {
                fontWeight: "bold",
              },
            },
          },
        },
        labelLayout: {
          hideOverlap: false,
        },
        // itemStyle: {
        //   color: (params) =>
        //     selectedPalette[params.dataIndex % selectedPalette.length],
        // },
      });
      titles.push({
        text: `{indicator|${formatTitle(indicatorName + " " + indicator_date)}}\n{location|${locationName}} {geo|(${geolevel})}`,
        left: center[0],
        top: getTitleTop(center[1], total),
        textAlign: "center",
        textStyle: {
          rich: {
            indicator: {
              fontSize: 14,
              fontWeight: "bold",
              color: "#000",
              lineHeight: 20,
            },
            location: {
              fontSize: 14,
              fontWeight: "bold",
              //color: "#666",
              color: "#5677fa",
              lineHeight: 16,
            },
            geo: {
              fontSize: 12,
              //color: "#666",
              color: "#5677fa",
              lineHeight: 16,
            },
          },
        },
      });
    });

    return {
      title: titles,
      tooltip: { trigger: "item" },
      dataset: datasets,
      series,
      color: selectedPalette,
      legend:
        total === 1
          ? {
            orient: "horizontal",
            bottom: 0,
            type: "plain",
            itemGap: 10,
            data: datasets[0]?.source?.slice(1).map((row) => row[0]) || [],
          }
          : [],
    };
  };


  const multiPieOption = buildMultiPieOption();
  const getMinHeight = (total, isLocationPage) => {
    if (isLocationPage) return "50vh"; // always 50vh for location page

    switch (total) {
      case 1:
        return "70vh";
      case 2:
        return "80vh";
      case 3:
        return "90vh";
      case 4:
        return "100vh";
      default:
        return "70vh";
    }
  };
  /////////////////////////
  ///  export feature 
  /////////////////////////

  const handleMatrixCSVDownload = () => {//const handleMatrixCSVDownload = () => {
    if (!apiData?.indicator_values || apiData.indicator_values.length === 0) return;

    const indicators = apiData.indicator_values;

    // Prepare headers: indicator name and subindicator labels
    const indicatorHeaders = indicators.map((indicator) => ({
      i_name: indicator.indicator_name,
      i_code: indicator.indicator_code,
      unit: indicator.unit,
      subindicators: Array.from(
        new Set(
          indicator.location_values?.flatMap((loc) =>
            loc.values?.map((item) => Object.keys(item)[0])
          ) || []
        )
      ),
    }));

    // All unique location names
    const allLocations = Array.from(
      new Set(
        indicators.flatMap((indicator) =>
          indicator.location_values?.map((loc) => loc.location_name)
        )
      )
    );

    // Build a map: location -> indicator -> subindicator -> value
    const locationDataMap = {};

    indicators.forEach((indicator) => {
      const indicatorCode = indicator.indicator_code;
      indicator.location_values?.forEach((loc) => {
        const locName = loc.location_name;

        if (!locationDataMap[locName]) locationDataMap[locName] = {};
        if (!locationDataMap[locName][indicatorCode]) locationDataMap[locName][indicatorCode] = {};

        loc.values?.forEach((item) => {
          const [key, value] = Object.entries(item)[0];
          locationDataMap[locName][indicatorCode][key] = value;
        });
      });
    });

    const csvRows = [];

    // First row: indicator names (spanning multiple subindicators)
    const headerRow1 = ['"Location"'];
    indicatorHeaders.forEach((indicator) => {
      headerRow1.push(`"${indicator.i_name} (${indicator.unit || ''})"`);
      for (let i = 1; i < indicator.subindicators.length; i++) {
        headerRow1.push('""');
      }
    });
    csvRows.push(headerRow1.join(','));

    // Second row: subindicator names
    const headerRow2 = ['""'];
    indicatorHeaders.forEach((indicator) => {
      indicator.subindicators.forEach((sub) => {
        headerRow2.push(`"${sub}"`);
      });
    });
    csvRows.push(headerRow2.join(','));

    // Data rows: each location
    allLocations.forEach((locName) => {
      const row = [`"${locName}"`];
      indicatorHeaders.forEach((indicator) => {
        const subMap = locationDataMap[locName]?.[indicator.i_code] || {};
        indicator.subindicators.forEach((sub) => {
          const val = subMap[sub];
          row.push(val !== undefined && val !== null ? val : '—');
        });
      });
      csvRows.push(row.join(','));
    });

    // Create CSV file and trigger download
    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const timestamp = new Date().toISOString()
      .replace(/T/, '_')      // Replace 'T' with '_'
      .replace(/:/g, '-')     // Replace ':' with '-'
      .replace(/\..+/, '');   // Remove milliseconds
    const filename = `pie/donut_chart_${timestamp}.csv`;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const handleExportImage = () => {
    if (!chartRef.current) return;
    const instance = chartRef.current.getEchartsInstance();
    const url = instance.getDataURL({
      type: "png",
      pixelRatio: 2,
      backgroundColor: "#fff",
    });

    const link = document.createElement("a");
    link.href = url;
    const timestamp = new Date().toISOString()
      .replace(/T/, '_')      // Replace 'T' with '_'
      .replace(/:/g, '-')     // Replace ':' with '-'
      .replace(/\..+/, '');   // Remove milliseconds
    link.download = `pie/donut_chart_image_${timestamp}.png`;
    link.click();
  };

  const geoLevelLabel = (level) => {
    switch (level) {
      case 1: return "National";
      case 2: return "State / UT";
      case 3: return "District";
      case 4: return "ULG";
      default: return "Unknown";
    }
  }

  return (
    <><WorkspaceButton
      showWorkspace={showWorkspace}
      setShowWorkspace={setShowWorkspace}
    />
      <WorkspaceSidePanel showWorkspace={showWorkspace}
        setShowWorkspace={setShowWorkspace}
        onVisualize={handleVisualize}
        onSaveSuccess={handleSaveSuccess} />
      <div className="container-fluid" style={{ height: "100%", width: "100%" }}>
        {location.pathname === "/piechart" && (
          <div className="row mb-3 p-2">
            <div className="col-12">
              <h3 className="fw-bold">Data Analysis</h3>
              <hr />
            </div>
          </div>
        )}
        <div className="row">
          {/* Controls */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-primary"
                onClick={() => setShowFilterPopup(true)}
              >
                <FaFilter className="me-1" /> Filters
              </button>
              {location.pathname !== "/location" && (
                <><button
                  className="btn btn-outline-secondary"
                  onClick={() =>
                    navigate("/mapconfig", { state: currentPayload })
                  }
                >
                  <FaSlidersH className="me-1" /> Go Back to Chart Configuration
                </button><OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="filter-tooltip">
                      <ol className="mb-0 ps-3">
                        <li>Click on 'Go to Chart configuration' to add more indicators to the chart from the workspace.</li>
                        <li>Go to 'Home' menu link to add additional indicators to the workspace.</li>
                      </ol>
                    </Tooltip>
                  }
                >
                    <span>
                      <MdInfoOutline size={20} style={{ cursor: "pointer", color: "#000000" }} />
                    </span>
                  </OverlayTrigger>
                  <SaveCharts className="" payload={currentPayload} formattedPayload={currentFormattedPayload} path="/piechart" reduxPayload={reduxPayload} />
                </>
              )}

            </div>
            {!isMobile && (
              <div className="d-flex dropdown end-0 align-items-right position-relative gap-2">
                {/* <button className="btn btn-sm btn-primary " onClick={handleMatrixCSVDownload}>
              Export CSV
            </button> */}
                <div>
                  <button
                    className="btn btn-sm btn-primary text-end"
                    type="button"
                    onClick={() => setExportDropdownOpen((prev) => !prev)}
                  >
                    Export {isExportDropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
                  </button>
                  {isExportDropdownOpen && (
                    <ul
                      className="dropdown-menu show"
                      style={{
                        display: "block",
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        zIndex: 1000,
                      }}
                    >
                      <li>
                        <button className="dropdown-item" onClick={handleMatrixCSVDownload}>
                          Export as CSV
                        </button>
                      </li>
                      <li>
                        <button className="dropdown-item" onClick={handleExportImage}>
                          Export as Image
                        </button>
                      </li>
                    </ul>
                  )}</div>
                <div>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => setChartOptionOpen(!isChartOptionOpen)}
                  >
                    Chart Options {isChartOptionOpen ? <FaChevronUp /> : <FaChevronDown />}
                  </button>

                  {isChartOptionOpen && (
                    <div
                      className="position-absolute bg-white border rounded shadow p-3"
                      style={{ top: '100%', right: 0, zIndex: 1000, minWidth: '150px' }}
                    >
                      <ColorPalette onSelectPalette={setSelectedPalette} />
                    </div>
                  )}
                </div>
              </div>)}
          </div>

          {/* Single chart container with multiple pies */}
          <div className="col-12" style={{ minHeight: getMinHeight(total, isLocationPage) }}>
            <div className="card shadow-sm">
              <div className="card-body">
                <ReactECharts
                  ref={chartRef}
                  option={multiPieOption}
                  style={{ height: isMobile ? "auto" : "700px", minHeight: getMinHeight(total, isLocationPage), width: isMobile ? "300px" : "1600px" }}
                />
              </div>
            </div>
          </div>
          {showFilterPopup && (
            <Piechart_FilterPopup
              show={showFilterPopup}
              onClose={() => setShowFilterPopup(false)}
              onApply={handleFilterApply}
              mainpayload={mainpayload}
              selectedItems={selectedLocations}
              setSelectedItems={setSelectedLocations}
              workspace_locations={mainformattedpayload?.location_info || []}
              fetchLocations={fetchLocations}
            />
          )}
          {/* Info sections (Indicators & Locations) */}
          {location.pathname === "/piechart" && (
            <div className="col-12" style={{ height: "30%" }}>
              <div className="row h-100">
                {/* Indicators */}
                <div
                  className="col-md-8 bg-light p-3"
                  style={{ overflowY: "auto" }}
                >
                  <h5 className="f-14 fw-bold">Chart Indicators</h5>
                  {(() => {
                    const selectedICodes = mainpayload?.indicators || [];

                    const indicatorsInfo = mainformattedpayload?.indicator_info
                      ? Object.values(mainformattedpayload?.indicator_info).filter((ind) =>
                        selectedICodes.includes(ind.indicator_code?.toString())
                      )
                      : [];
                    return indicatorsInfo.length === 0 ? (
                      <p className="text-muted">No indicators selected</p>
                    ) : (
                      <ul className="list-group mb-3">
                        {indicatorsInfo.map((ind, index) => (
                          <li
                            key={ind.indicator_code || index}
                            className="list-group-item"
                          >
                            <div className="d-flex align-items-start">
                              <span className="badge bg-secondary me-2">
                                {index + 1}
                              </span>
                              <div>
                                <div className="fw-bold text-primary" style={{ fontSize: "13px" }}>
                                  {ind.indicator_name && (
                                    <>
                                      <span>{ind.indicator_name}</span>
                                      {ind.dataset_name && <span> ({ind.dataset_name})</span>}
                                    </>
                                  )}

                                  {ind.indicator_date && ind.indicator_date !== "NA" && (
                                    <>
                                      {" | "}
                                      <span
                                        style={{
                                          backgroundColor: "#2c7ce5",
                                          color: "#fff",
                                          padding: "0 6px",
                                          borderRadius: "4px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {ind.indicator_date}
                                      </span>
                                    </>
                                  )}

                                  {ind.agency_name && ind.agency_name !== "NA" && (
                                    <>
                                      {" | "}
                                      <span>{ind.agency_name}</span>
                                    </>
                                  )}

                                  {/* {Array.isArray(ind.geo_levels) && ind.geo_levels.length > 0 && (
                                    <>
                                      {" | "}
                                      <span>{ind.geo_levels.join(", ")}</span>
                                    </>
                                  )} */}
                                </div>
                                <div className="text-muted small">
                                  {/* Available Geo Levels Section */}
                                  {ind.geo_levels && ind.geo_levels.length > 0 && (
                                    <div className="mt-1 mb-1">
                                      <span className="me-2" style={{ fontSize: "0.875rem" }}>Available Geo Levels:</span>
                                      {ind.geo_levels.map((level, idx) => (
                                        <span
                                          key={idx}
                                          style={{
                                            backgroundColor: "#28a745",
                                            color: "#fff",
                                            borderRadius: "0.25rem",
                                            padding: "0.2rem 0.5rem",
                                            marginRight: "0.3rem",
                                            fontSize: "0.75rem",
                                            display: "inline-block"
                                          }}
                                        >
                                          {level}
                                        </span>
                                      ))}
                                    </div>
                                  )}
                                  {[
                                    ind.sector_name,
                                    ind.sub_sector_name,
                                    ind.sub_sub_sector_name,
                                  ]
                                    .filter((val) => val && val !== "NA")
                                    .join(" | ")
                                  }
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    );
                  })()}
                </div>

                {/* Locations */}
                <div
                  className="col-md-4 bg-light p-3"
                  style={{ overflowY: "auto" }}
                >
                  <h5 className="f-14 fw-bold">Locations</h5>
                  {(() => {
                    const lgdCodes = mainpayload?.lgd_codes || [];
                    const lgdCodeSet = new Set(lgdCodes.map((l) => l.code));

                    // Filter the locations based on lgd codes
                    let locations = (mainformattedpayload?.location_info || []).filter(
                      (loc) => lgdCodeSet.has(loc.properties?.code)
                    );

                    // Check if India (code 1000, geo_level_code 1) should be added
                    const shouldAddIndia = lgdCodes.some(
                      (l) => l.code === 1000 && l.geo_level_code === 1
                    );

                    if (shouldAddIndia) {
                      // Avoid duplication if already present
                      const alreadyIncluded = locations.some((loc) => loc.properties?.code === 1000);
                      if (!alreadyIncluded) {
                        locations.unshift({
                          name: "India",
                          properties: { code: 1000, geo_level_code: 1 },
                          geo_level_code: 1
                        });
                      }
                    }

                    return locations.length === 0 ? (
                      <p className="text-muted">No locations selected</p>
                    ) : (
                      <ul className="list-group mb-3">
                        {locations.map((loc, idx) => (
                          <li key={`loc-${idx}`} className="list-group-item">
                            <div className="d-flex align-items-start">
                              <span className="fw-bold f-14">{idx + 1}.&nbsp;</span>
                              <div className="fw-bold f-14">{loc.name}<span className="small text-secondary f-12">({geoLevelLabel(loc.geo_level_code || loc.geo_level || 4)})</span></div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    );
                  })()}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </>
  );
};

export default PieChart;
